import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { CartStore } from '../../../stores/CartStore';
import styles from './CartPopUp.css';
import smallPeak from './pop-up-images/cart-popup-chevron.png';
import { ProductImage } from '../../product-image';
import { constants } from '../../../config';
import { ScreenStore } from '../../../stores/ScreenStore';
import { SecondaryButton } from '../../../common/secondary-button';
import { AppLink, routeNaming } from '../../../routes';
import { ProductHelper } from '../../../helpers/ProductHelper';
import { InfoModal } from '../../info-modal';
import { ConfigParametersStore } from '../../../stores/ConfigParametersStore';

const IPropTypes = {
  className: PropTypes.string,
};

const defaultProps = {
  className: '',
};

const CartPopUp = (props) => {
  if (CartStore.lastProductUpdated === null) {
    return null;
  }
  const isArticleInPresale = ConfigParametersStore.isValueInFeatureFlagData('product_next_deliveries', CartStore.lastProductUpdated.product.id);
  const mobileVersion = ScreenStore.screenWidth <= constants.breakpoints.mobileThreshold;
  return (
    <div className={[styles.mainContainer, props.className].join(' ')}>
      {!mobileVersion &&
        <img src={smallPeak} alt="" className={styles.peakSvg} />
      }
      <div className={styles.contentContainer}>
        <div className={styles.header}>
          <span className={styles.text}>Artículo agregado al carrito</span>
          {CartStore.cart &&
            <span className={styles.countProducts}>
              {`${CartStore.cartTotalItems} producto${CartStore.cartTotalItems > 1 ? 's' : ''} `}
            </span>
          }
        </div>
        <div className={styles.content}>
          <div className={styles.productData}>
            <ProductImage
              className={mobileVersion ? styles.imageMobile : styles.image}
              src={CartStore.lastProductUpdated.product.coverImage}
              size={mobileVersion ? 'sm' : 'md'}
            />
            <div className={styles.productInformation}>
              <p className={styles.brand}>
                {CartStore.lastProductUpdated.product.brand}
              </p>
              <p className={styles.nameProduct}>
                {CartStore.lastProductUpdated.product.name}
              </p>
              <p>$
                {
                  ProductHelper.priceStringFor(
                    CartStore.lastProductUpdated.product,
                    CartStore.lastProductUpdated.hasService,
                  )
                }
              </p>
              {
                !!CartStore.lastProductUpdated.product.serviceProduct &&
                !CartStore.lastProductUpdated.hasService &&
                <p className={styles.noServiceMessage}>
                  {isArticleInPresale ? CartStore.lastProductUpdated.product.textsService[8]
                   : CartStore.lastProductUpdated.product.textsService[2]}
                </p>
              }
              {
                !!CartStore.lastProductUpdated.product.serviceProduct &&
                CartStore.lastProductUpdated.hasService &&
                <InfoModal
                  id="servicio-instalación-covid"
                  type="component"
                  showConfirm={false}
                  textCancel="Cerrar"
                  showModal={constants.activeCovid}
                >
                  <p className={styles.hasServiceMessage}>
                    {isArticleInPresale ? CartStore.lastProductUpdated.product.textsService[8]
                    : CartStore.lastProductUpdated.product.textsService[1]}
                  </p>
                </InfoModal>
              }
            </div>
          </div>
        </div>
        <AppLink
          routeName={routeNaming.CART}
        >
          <SecondaryButton
            className={styles.button}
          >
            Ver carrito
          </SecondaryButton>
        </AppLink>
      </div>
    </div>
  );
};

CartPopUp.propTypes = IPropTypes;
CartPopUp.defaultProps = defaultProps;

const ObservedCartPopUp = observer(CartPopUp);

export { ObservedCartPopUp as CartPopUp };



// WEBPACK FOOTER //
// ./src/common/home-navbar/cart-pop-up/CartPopUp.jsx